import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  .suggestion-link {
    background: ${colors.grayExtraLight};
    border-radius: 25px;
    display: block;
    padding: 10px 20px;
    margin: 0.7rem 0;
    text-align: center;
    text-decoration: none;
    width: 100%;
  }

  .suggestion-link > .keyword {
    display: block;
    margin-bottom: 0.5em;
  }

  .suggestion-link > .results {
    color: ${colors.grayDark};
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./app/Suggestions/components/SuggestionItem/styles.js